import React from "react";
import {
  ParagraphContentType,
  ParagraphTnc,
  TYPE_PARAGRAPH,
} from "../../../../components/paragraph-tnc";

import IMG_PMK_SHARIA_2 from "../../../../assets/sharia-img-2.png";
import IMG_PMK_SHARIA_3 from "../../../../assets/sharia-img-3.png";
import IMG_PMK_SHARIA_4 from "../../../../assets/sharia-img-4.png";
import IMG_PMK_SHARIA_5 from "../../../../assets/sharia-img-5.png";
import IMG_PMK_SHARIA_6 from "../../../../assets/sharia-img-6.png";
import IMG_PMK_SHARIA_7 from "../../../../assets/sharia-img-7.png";
import IMG_PMK_SHARIA_8 from "../../../../assets/sharia-img-8.png";
import IMG_PMK_SHARIA_9 from "../../../../assets/sharia-img-9.png";
import IMG_PMK_SHARIA_10 from "../../../../assets/sharia-img-10.png";
import {
  tcAttachment3Page31,
  tcAttachmentPage26,
  tcAttachmentPage29AADPromotion,
  tcAttachmentPage29ADPromotion,
  tcShariaContent,
} from "./pmk-sharia-content.data";
import { TAgentDetail } from "../../pk-pmk-tnc.screen";
import { ImageView } from "../../../../components/image-view";

export const PMKShariaContent = ({ agentDetail }: { agentDetail: TAgentDetail }) => {
  const { innerWidth } = window;

  const fontParagraph = "text-xs text-justify text-[#666666] font-semibold";
  const fontHeader = "text-sm text-justify text-[#666666] ";

  const getWidthImage = (width: number) => {
    if (width > innerWidth) {
      return innerWidth;
    } else {
      return width;
    }
  };
  return (
    <>
      <div className="px-4 py-3 text-center">
        <h1 className="text-base font-bold text-[#333333] ">PERJANJIAN MANAJER KEAGENAN</h1>
        <h1 className="text-base font-bold text-[#333333] ">PT PRUDENTIAL SHARIA LIFE ASSURANCE</h1>
      </div>
      <div className="px-4 ">
        <p className={fontParagraph}>
          PERJANJIAN MANAJER KEAGENAN ini ("Perjanjian") dibuat oleh dan antara:
        </p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>1.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            PT PRUDENTIAL SHARIA LIFE ASSURANCE
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            Prudential Tower, Jl, Jendral Sudirman kav 79, Jakarta Selatan 12910
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            (021) 2995 8577
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>(selanjutnya disebut sebagai "Perusahaan")</p>
        <div className="w-full flex flex-row mt-1 gap-1  ">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left bg-red`}>2.</p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%]  text-left`}>Nama</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.name || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>Alamat</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.address || "-"}
          </p>
        </div>
        <div className="w-full flex flex-row gap-1">
          <p className={`text-xs text-[#666666] font-semibold w-[5%] text-left`}></p>
          <p className={`text-xs text-[#666666] font-semibold w-[15%] text-left`}>No. Telp</p>
          <p className={`text-xs text-[#666666] font-semibold text-left`}>:</p>
          <p className={`text-xs text-[#666666] font-semibold w-[78%] text-left`}>
            {agentDetail?.phoneNumber || "-"}
          </p>
        </div>
        <p className={fontParagraph + " ml-[6%]"}>
          (selanjutnya disebut sebagai "Manajer Keagenan").
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan dan Manajer Keagenan secara bersama-sama selanjutnya dapat disebut "Para Pihak"
          dan secara sendiri-sendiri disebut "Pihak".
        </p>
        <p className={`${fontHeader} font-bold mt-1`}>BAHWA:</p>
        <p className={`${fontParagraph} mt-1 `}>
          Perusahaan bermaksud menunjuk Manajer Keagenan untuk melakukan pemasaran Produk Asuransi
          Syariah (sebagaimana didefinisikan di bawah ini) dan Manajer Keagenan bersedia untuk
          menerima penunjukan Perusahaan berdasarkan syarat-syarat dan ketentuan-ketentuan
          sebagaimana diatur dalam Perjanjian ini.
        </p>
        <p className={`${fontParagraph} mt-1 `}>
          Dengan tetap memperhatikan ketentuan dalam Perjanjian ini, Perjanjian akan dilaksanakan
          atas akad ju’alah, dimana Perusahaan berjanji dan berkomitmen untuk memberikan Imbalan (
          <i>reward</i>/`iwadh/ju`l) tertentu atas pencapaian hasil (<i>natijah</i>) yang ditentukan
          dari pelaksanaan Jasa oleh Manajer Keagenan sebagaimana diatur dalam Perjanjian ini
          (selanjutnya disebut <b>“Akad Ju’alah”</b>).
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>MAKA</b>, dengan ini Para Pihak sepakat dan setuju atas syarat-syarat dan
          ketentuan-ketentuan sebagai berikut:
        </p>
        <ParagraphTnc
          content={tcShariaContent as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />

        <p className={`${fontHeader} mt-1`}>
          <b>Lampiran I</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>
            Ketentuan <i>Overriding</i>
          </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <i>Overriding</i> ("OR") yang dapat diterima oleh Manajer Keagenan akan dihitung
          berdasarkan ketentuan di bawah ini:
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_2}
          alt="IMG_PMK_SHARIA_2"
          className={`mt-0.5`}
          style={{ width: getWidthImage(500) }}
        />
        <p className={`${fontParagraph} mt-1`}>
          <b>
            <i>Basic Generation</i> OR
          </b>
        </p>
        <p className={`${fontParagraph}`}>
          <i>Basic Generation OR</i> adalah <i>overriding</i> yang diberikan kepada AD yang memiliki
          1 <i>direct AD</i> atau lebih di bawah generasinya.
        </p>
        <p className={`${fontParagraph}`}>
          Berikut adalah tabel tingkat <i>Basic Generation OR</i> untuk setiap generasi:
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_3}
          alt="IMG_PMK_SHARIA_3"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(500) }}
        />

        <p className={`${fontParagraph} mt-1`}>
          Jumlah minimum direct AD mempengaruhi tingkat kedalaman OR Generasi yang didapatkan.
          Berikut pilihannya:
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_4}
          alt="IMG_PMK_SHARIA_4"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(270) }}
        />
        <ImageView
          src={IMG_PMK_SHARIA_5}
          alt="IMG_PMK_SHARIA_5"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(270) }}
        />
        <ImageView
          src={IMG_PMK_SHARIA_6}
          alt="IMG_PMK_SHARIA_6"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(270) }}
        />
        <ImageView
          src={IMG_PMK_SHARIA_7}
          alt="IMG_PMK_SHARIA_7"
          className={`mt-0.5 `}
          style={{ width: getWidthImage(270) }}
        />

        <p className={`${fontParagraph} mt-1`}>
          Khusus untuk <b>PRU</b>Corporate Life, <b>PRU</b>Corporate Medical, <b>PRU</b>Corporate
          Personal Accident:
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_8}
          alt=""
          className={`mt-0.5 `}
          style={{ width: getWidthImage(250) }}
        />
        <p className={`${fontParagraph} mt-1`}>
          <b>
            Ketentuan umum perhitungan <i>Generation</i> OR adalah sebagai berikut:
          </b>
        </p>
        <ParagraphTnc content={tcAttachmentPage26} type={TYPE_PARAGRAPH.NUMBERING} />

        {/* LAMPIRAN II */}

        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran II</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>Ketentuan Promosi</b>
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_9}
          alt="IMG_PMK_SHARIA_9"
          className={`mt-0.5`}
          style={{ width: getWidthImage(1000) }}
        />

        <p className={`${fontParagraph} mt-1.5`}>
          Berikut adalah ketentuan-ketentuan lain yang berlaku bagi promosi AD:
        </p>

        <ParagraphTnc
          content={tcAttachmentPage29ADPromotion as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.NUMBERING}
        />
        <p className={`${fontParagraph} mt-0.5`}>
          Berikut adalah ketentuan-ketentuan lain yang berlaku bagi promosi AAD:
        </p>
        <ParagraphTnc
          content={tcAttachmentPage29AADPromotion as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.NUMBERING}
        />

        <p className={`${fontParagraph} mt-1`}>
          Informasi lengkap terkait Ketentuan Promosi mengacu pada <i>Agency Update</i> yang
          berlaku.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          <b>
            Validasi <i>Maintenance of Contract – MOC</i>
          </b>
        </p>
        <ImageView
          src={IMG_PMK_SHARIA_10}
          alt="IMG_PMK_SHARIA_10"
          className={`mt-0.5`}
          style={{ width: getWidthImage(500) }}
        />

        <p className={`${fontParagraph} mt-1`}>
          Ketentuan Promosi dan Validasi <i>MOC</i> dapat sewaktu-waktu berubah mengikuti ketentuan
          yang ditetapkan oleh Perusahaan melalui Peraturan Keagenan.
        </p>
        {/* LAMPIRAN III */}
        <p className={`${fontHeader} mt-1.5`}>
          <b>Lampiran III</b>
        </p>
        <p className={`${fontHeader} mt-1`}>
          <b>Syarat dan Ketentuan Perjanjian Manajer Keagenan</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>Standar Praktik Kode Etik Agen Asuransi Jiwa Syariah</b>
        </p>
        <p className={`${fontHeader} mt-0.5`}>
          <b>LATAR BELAKANG </b>
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Perusahaan menyadari pentingnya reputasi yang baik. Untuk memelihara reputasi yang baik
          dibutuhkan tanggung jawab dan profesionalisme tinggi dari setiap pelaku bisnis yang
          terlibat karena asuransi adalah bidang usaha yang berlandaskan pada kepercayaan dan
          kejujuran.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Prinsip-prinsip usaha dari Perusahaan adalah tindakan yang bertanggung jawab dengan
          integritas yang baik, patuh dengan hukum dan peraturan serta menghormati budaya dan
          tradisi masyarakat Indonesia. Manajer Keagenan Asuransi Jiwa Syariah Perusahaan (“Manajer
          Keagenan”) sebagai salah satu pelaku bisnis asuransi yang berpengaruh terhadap reputasi
          Perusahaan harus dilengkapi dengan suatu Kode Etik dan Perilaku untuk menghindari benturan
          kepentingan, penyalahgunaan jabatan dan penyalahgunaan informasi.
        </p>
        <p className={`${fontParagraph} mt-1`}>
          Standar Praktik Kode Etik Agen Asuransi Jiwa Syariah ini (“Kode Etik”) ditujukan agar
          setiap Manajer Keagenan selalu bertindak dengan etis, konsisten dan penuh integritas
          sesuai dengan prinsip Perusahaan dalam membangun kepercayaan dari (calon) Nasabah. Yang
          dimaksud dengan Nasabah dalam Standar Praktik Kode Etik Agen Asuransi Jiwa adalah Nasabah
          sebagaimana didefinisikan dalam Perjanjian, Tertanggung Utama atau Penerima Manfaat.
          Selain itu, kepatuhan Agen terhadap hukum dan peraturan serta rasa hormat terhadap tradisi
          dan budaya Indonesia mencerminkan bahwa praktik penjualan akurat, lengkap, berimbang dan
          memenuhi etika standar. Dengan demikian Kode Etik ini wajib dipatuhi oleh setiap Manajer
          Keagenan dalam menjalankan profesinya.
        </p>
        <ParagraphTnc
          content={tcAttachment3Page31 as ParagraphContentType[]}
          type={TYPE_PARAGRAPH.PARAGRAPH}
        />
        <div className="mt-14">
          <p className={`${fontParagraph} mt-1.5 text-end`}>PAO/PMK/S/V1021</p>
        </div>
      </div>
    </>
  );
};
